var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{class:("progress__bar " + (_vm.data.length > 2 ? 'progress__bar--multiple' : 'progress__bar--simple'))},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"progress__bar__item",style:({
        width: (item + "%"),
        zIndex: _vm.data.length - index
      }),attrs:{"data-progress-item":index}})}),0),(_vm.data.length > 2)?_c('div',{staticClass:"progress__count"},[_vm._v(" 533 ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }